module.exports = __webpack_public_path__ + "img/arrow-down.6a6b0c49.svg";